// Actions
import { useSelector } from 'react-redux';

// Types
import { ReduxState } from '@/redux/modules/types';
import { ThemeVersionInfo } from '@/types/theme-mode';

// Utils
import { getThemeVersion } from '@/utils/theme';

/**
 * A custom hook that retrieves the current theme version from the user's preferences.
 *
 * Used by the functional wrappers components to determine the theme version to render.
 *
 * @returns An object containing:
 * - `userTheme`: The current theme version, which defaults to `ThemeMode.DEFAULT` if not set.
 * - `isLightVersion`: A boolean indicating whether the current theme version is the light version.
 */
const useThemeVersion = (): ThemeVersionInfo => {
  const auth = useSelector((state: ReduxState) => state.auth);
  return getThemeVersion(auth.user);
};

export default useThemeVersion;
